export default "__VITE_ASSET__0df169a4__"